<template>
    <div class="sms-phone-options-selector-container">
        <ds-multiselect
            v-model="internalValue"
            bind-value-only
            data-qa="sms-phone-options-selector"
            class="sms-phone-options-selector"
            multiple
            :options="options"
            placeholder="Only send to these phone types"
            required
            searchable
            :force-invalid="showError"
            @input="handleInput"
        >
            <template #help>
                <span v-if="showError && internalValue.length === 0">
                    {{ helpText }}
                </span>
            </template>
        </ds-multiselect>

        <slot name="footer" />
    </div>
</template>

<script>
import { PHONE_FIELDS, PHONE_TYPES } from '@/components/automatedSms/sms.constants';

export default {

    props: {
        showError: Boolean,
        value: {
            type: Array,
            default: () => [],
        },
        optStatuses: {
            type: Array,
            default: () => [],
        },
        recipients: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            internalValue: [],
            options: [
                {
                    label: 'Phone fields 1 - 5',
                    options: [
                        { value: PHONE_FIELDS.PHONE1, label: 'Phone 1' },
                        { value: PHONE_FIELDS.PHONE2, label: 'Phone 2' },
                        { value: PHONE_FIELDS.PHONE3, label: 'Phone 3' },
                        { value: PHONE_FIELDS.PHONE4, label: 'Phone 4' },
                        { value: PHONE_FIELDS.PHONE5, label: 'Phone 5' },
                    ],
                },
                {
                    label: 'Phone number types',
                    options: [
                        { value: PHONE_TYPES.MOBILE, label: 'Mobile' },
                        { value: PHONE_TYPES.WORK, label: 'Work' },
                        { value: PHONE_TYPES.HOME, label: 'Home' },
                        { value: PHONE_TYPES.OTHER, label: 'Other' },
                    ],
                },
            ],
        };
    },

    watch: {
        value: {
            handler(value) {
                const internalArray = this.internalValue.map((item) => item).sort();
                const valueArray = value.map((item) => item).sort();

                if (JSON.stringify(internalArray) !== JSON.stringify(valueArray)) {
                    this.internalValue = value;
                }
            },
            immediate: true,
            deep: true,
        },
    },

    computed: {
        helpText() {
            return 'Please select 1 phone number type to continue.';
        },
    },

    methods: {
        handleInput(value) {
            this.internalValue = value;

            this.$emit('input', value);
        },
    },
};
</script>

<style lang="scss" scoped>
    .sms-phone-options-selector {
        --dropdown-height: 400px;
        margin-bottom: 0;
    }

</style>
